export default class BaseScreenProvider {
    detectScreen() {
        return "all";
    }
}
